import { CalendarIcon } from "../../assets";
import { COLORS } from "../../constants";
import { formatNumberToLocaleString } from "../../utils/methods";
import LoggedContainer from "../LoggedContainer";
import styles from "./styles.module.scss";

type WeightSectionProps = {
  weight: number;
  weightUnit: "kg" | "lbs";
  isSkipped: boolean;
};

const WeightSection: React.FC<WeightSectionProps> = ({
  weight,
  weightUnit,
  isSkipped,
}) => {
  return (
    <div className={styles.wrapper}>
      <h6>Weight</h6>
      <LoggedContainer isSkipped={isSkipped} status="logged" order="single">
        <div className={styles.contentContainer}>
          <div
            className={styles.iconContainer}
            style={{
              backgroundColor: isSkipped
                ? COLORS.mediumGray
                : COLORS.orangeOpacity20,
            }}
          >
            <CalendarIcon
              style={{
                fill: isSkipped ? COLORS.darkGray : COLORS.orange,
              }}
            />
          </div>
          <p>
            {formatNumberToLocaleString(weight, 0)} {weightUnit}
          </p>
        </div>
      </LoggedContainer>
    </div>
  );
};

export default WeightSection;
